import { Typography, useTheme } from '@mui/material';
import { useTransition, type JSX } from 'react';
import { Checkbox } from '../../Checkbox/Checkbox';
import { Icon, IconTypes } from '../../Icon';
import { IconBtn, MenuTogglerContainer } from '../styled';
import { MenuTogglerProps } from '../types';

export const MenuToggler = ({
  name,
  open,
  checked,
  indeterminate,
  onOpenClose,
  onSelectAllNone,
  showToggler = true,
  className,
  checkboxVariant = 'secondary',
}: MenuTogglerProps): JSX.Element => {
  const theme = useTheme();
  const startTransition = useTransition()[1];

  return (
    <MenuTogglerContainer showToggler={showToggler} className={className}>
      {showToggler && onOpenClose && (
        <IconBtn onClick={onOpenClose} open={open}>
          <Icon type={IconTypes.ARROW_DOWN} color={theme.colors.neutral[60]} />
        </IconBtn>
      )}
      <Checkbox
        checked={checked}
        indeterminate={indeterminate}
        handleChange={() => {
          startTransition(() => {
            onSelectAllNone();
          });
        }}
        variant={checkboxVariant}
      />
      <Typography variant='subtitle2' color={'text.primary'}>
        {name}
      </Typography>
    </MenuTogglerContainer>
  );
};
